import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaymentPageApi } from 'src/app/api/payment-page/payment.page.api.class';
import { ApplicationPaymentPageFormData } from 'src/app/interfaces/paymentPage/application-payment-page-form-data';

@Injectable({
  providedIn: 'root'
})
export class PaymentPageService {

  constructor(private paymentPageApi:PaymentPageApi) {
   }

   public getApplicationPaymentPageData(token:string): Observable<any> {
    return this.paymentPageApi.getApplicationPaymentPageData(token);
  }

  public getJWToken(payload:ApplicationPaymentPageFormData,token:string):Observable<any>{
    return this.paymentPageApi.getJWToken(payload,token);
  }

  public getMerchantInformation(token:string):Observable<any>{
    return this.paymentPageApi.getMerchantInformation(token);
  }

  public getMerchantConfig(merchantUid:string, applicationUid:string):Observable<any>{
    return this.paymentPageApi.getMerchantConfig(merchantUid,applicationUid);
  }

  public login():Observable<any>{
    return this.paymentPageApi.login();
  }
}
